export enum SettingsOption {
    /*
    SECTIONS = 'Secțiuni',
    PERMISIUNI = 'Permisiuni',
    PERMISIUNI_ACTIUNI = 'Acțiuni Permisiuni',
    FUNCTII = 'Funcții',
    */
    // JUDET = 'Județe',
    REQUEST_TYPES = 'Tipuri Cerere',
    CERERE_PRIORITY = 'Prioritate Cerere',
    STATUS = 'Status Cerere',
    // CERERE_SABLOANE = 'Șabloane Cereri',
    UAT = 'Unități administrativ teritoriale',
    OPERATORI = 'Operatori',
    DIRECTIE_COMPARTIMENTE = 'Direcție Compartimente'

    /*
    PLATFORM_SECTION = 'Secțiuni Platformă',
    PLATFORM_FAQ = 'FAQ Platformă',
    PLATFORM_CONTENT = 'Conținut Platformă',
    PLATFORM_ANNOUNCES = 'Anunțuri Platformă',
    */
}

export enum AdminSettings {
    CONFIGURARI = 'Configurări',
    TYPE_IMAGE_DIMENSIONS = 'Dimensiuni Tip Imagini',
    CRONS = 'Cron-uri',
}
